import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Address } from '../../../interfaces/location/address.interface';
import { FavoritesService } from '../../../services/favorites/favorites.service';
import { FavoriteAddresses } from '../../../interfaces/favorites/favorite-addresses.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { HOME, SET_HOME_ADDRESS, SET_WORK_ADDRESS, WORK } from '../../../constants/multi-language.constants';

@Component({
    selector: 'app-favorite-locations',
    templateUrl: './favorite-locations.component.html',
    styleUrls: ['./favorite-locations.component.scss'],
    standalone: false
})
export class FavoriteLocationsComponent implements OnInit{
  @Output() onHomeClick = new EventEmitter<Address>();
  @Output() onWorkClick = new EventEmitter<Address>();

  @Input() favoriteAddresses: FavoriteAddresses;

  /**
   * a11y: when true (e.g. in the "manage favorites" screen), clicking the home/work
   * row ALWAYS opens an edit dialog, so aria-haspopup="dialog" is exposed regardless
   * of whether the favorite is set. When false (default, used in the address-auto-
   * complete feed), the dialog only opens for un-set favorites; otherwise clicking
   * just picks the saved address.
   */
  @Input() alwaysOpensPopup: boolean = false;

  homeText: string
  workText: string
  setHomeText: string
  setWorkText: string

  constructor(private readonly languageService: LanguageService){}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
     this.homeText = HOME[language.language]
     this.workText = WORK[language.language]
     this.setHomeText = SET_HOME_ADDRESS[language.language]
     this.setWorkText = SET_WORK_ADDRESS[language.language]
    })
  }
}
